// extracted by mini-css-extract-plugin
export default {"wrapper":"LayersEditor_wrapper__g6gsD"};